import moment from "moment"

const FREQ_TO_PERIOD = {
  S: { unit: "weeks", value: 1 },
  Q: { unit: "weeks", value: 2 },
  M: { unit: "months", value: 1 },
  B: { unit: "months", value: 2 },
  T: { unit: "months", value: 3 },
  E: { unit: "months", value: 6 },
  A: { unit: "years", value: 1 },
}

const computeDataBruta = (dataInicio, frequencia, n) => {
  const period = FREQ_TO_PERIOD[frequencia]
  if (!period) return null
  const base = moment(dataInicio)
  const date = base.clone().add(period.value * n, period.unit)
  if (period.unit === "months" || period.unit === "years") {
    const targetDay = base.date()
    const lastDayOfTargetMonth = date.clone().endOf("month").date()
    date.date(Math.min(targetDay, lastDayOfTargetMonth))
  }
  return date.toDate()
}

export const isAjustada = (dataReal, dataInicio, frequencia, indice) => {
  if (indice === 0) return false
  const bruta = computeDataBruta(dataInicio, frequencia, indice)
  if (!bruta) return false
  return moment(bruta).format("YYYY-MM-DD") !== moment(dataReal).format("YYYY-MM-DD")
}

export const buildPreviewItems = (datasPreview, dataInicio, frequencia) => {
  return (datasPreview || []).map((data, idx) => ({
    indice: idx + 1,
    data,
    ajustada: isAjustada(data, dataInicio, frequencia, idx),
  }))
}
